"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.function.name");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.find");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

require("core-js/modules/es6.regexp.split");

var _slicedToArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.number.constructor");

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _mapWorld = require("./map-world.constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var MapWorldComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(MapWorldComponent, _Mixins);

  var _super = _createSuper(MapWorldComponent);

  function MapWorldComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, MapWorldComponent);
    _this = _super.apply(this, arguments); // public trafficLayer: any = null;

    _this.bounds = null;
    _this.hasRectangles = false;
    _this.rectangles = [];
    _this.markers = {};
    _this.currentColor = '#387fc2';
    _this.delayFactor = 0; // public directionsDisplay: any = null;

    _this.polyline = null;
    _this.polylineMarkers = [];
    return _this;
  }

  (0, _createClass2.default)(MapWorldComponent, [{
    key: "onSelectedShipRefsChange",
    value: function onSelectedShipRefsChange() {
      this.clearMarker();
      this.initPolyline(this.$props.routes, null, true);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.map = null; // this.trafficLayer = null;

      this.bounds = null;
      this.rectangles = []; // this.directionsDisplay = null;

      this.polyline = null;
      delete this.map; // delete this.trafficLayer;

      delete this.bounds;
      delete this.rectangles; // this.logger.info('map world is destroyed!');
    }
  }, {
    key: "created",
    value: function created() {
      this.defineWindowSelectMarker();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.refreshMap();
      });
    }
  }, {
    key: "defineWindowSelectMarker",
    value: function defineWindowSelectMarker() {
      var vm = this;

      window['selectMarkerByShipRefs'] = function (i) {
        vm.selectMarkerByShipRefs(i);
      };
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var _this3 = this;

      var routes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var zoom = 11;

      if (!this.helper.isUndefined(this.map)) {
        zoom = this.map.getZoom();
      }

      this.map = this.initMap(this.$props.locations, zoom);

      if (this.$props.hasUpdateEvent) {
        this.map.addListener('click', function (event) {
          if (_this3.hasRectangles) {
            switch (_this3.$props.initEvent) {
              case 'rectangles':
                _this3.$emit('updateLocation', {
                  latitude: event.latLng.lat(),
                  longitude: event.latLng.lng(),
                  option: 'add'
                });

                _this3.getRectangle(event.latLng);

                break;
            }
          }
        });
      }

      if (this.$props.initEvent) {
        var latLngs = routes ? routes : this.$props.routes;

        switch (this.$props.initEvent) {
          case 'polylines':
            var planId = this.helper.get(additionalData, 'planId', null);
            this.initPolyline(latLngs, planId, false); // this.initTrafficLayer();

            break;

          case 'rectangles':
            this.initAllRectangle(latLngs);
            break;

          case 'marker':
            this.initMarker(latLngs);
            this.fitBounds(latLngs);
            break;

          case 'selectedOrderMarker':
            this.initSelectedOrderMarker(latLngs, 0);
            this.fitBounds(latLngs);
            break;

          case 'polygon':
            this.initAllPolygon(latLngs);
            break;

          case 'heatmap':
            this.initAllHeatMap(latLngs);
            this.fitBounds(latLngs);
            break;
        }
      }
    }
  }, {
    key: "initMap",
    value: function initMap(center) {
      var zoom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 11;
      var element = this.$refs.googleMarker;
      return new google.maps.Map(element, {
        zoom: zoom,
        styles: _mapWorld.DEFAULT_MAP_STYLES,
        scrollwheel: false,
        navigationControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        clickableIcons: false,
        disableDoubleClickZoom: true,
        center: new google.maps.LatLng(center.latitude || 0, center.longitude || 0),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        gestureHandling: 'greedy'
      });
    }
    /*initTrafficLayer() {
        if (this.trafficLayer !== null) {
            this.trafficLayer.setMap(null);
            this.trafficLayer = null;
        }
         this.trafficLayer = new google.maps.TrafficLayer();
        this.trafficLayer.setMap(this.map);
         const toggleTrafficDiv = document.createElement('div');
        this.toggleTrafficView(toggleTrafficDiv);
        toggleTrafficDiv['index'] = 1;
        this.map.controls[google.maps.ControlPosition.LEFT_TOP].push(toggleTrafficDiv);
    }
     toggleTrafficView(controlDiv) {
        // Set CSS for the control border.
        const controlUI = document.createElement('div');
        controlUI.setAttribute('class', 'toggle-traffic');
        controlDiv.appendChild(controlUI);
         // Set CSS for the control interior.
        const controlText = document.createElement('div');
        controlText.setAttribute('class', 'text active');
        controlText.innerHTML = `${this.$i18n.t('planning.gMap.traffic')}`;
        controlUI.appendChild(controlText);
         controlUI.addEventListener('click', () => {
            if (this.trafficLayer.getMap() === null) {
                controlText.setAttribute('class', 'text active');
                this.trafficLayer.setMap(this.map);
            } else {
                controlText.setAttribute('class', 'text');
                this.trafficLayer.setMap(null);
            }
        });
    }*/

  }, {
    key: "getRectangle",
    value: function getRectangle(latLng) {
      var hashDataAdd = this.helper.hashEncode(latLng.lat(), latLng.lng(), this.$props.precision || 6);

      if (hashDataAdd) {
        this.addRectangle(this.helper.hashBounderies(hashDataAdd));
      }
    }
  }, {
    key: "initMarker",
    value: function initMarker(locations) {
      var _this4 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var hasLabel = locations.length > 1;
      var icon = {
        path: _mapWorld.PICK_ICON,
        fillColor: _mapWorld.DEFAULT_MAP_COLOR['blue'] || '#387fc2',
        fillOpacity: 0.8,
        strokeWeight: 0,
        scale: hasLabel ? 0.5 : 0.8,
        labelOrigin: {
          x: 0.9,
          y: 0
        }
      };

      if (!this.markers[index]) {
        this.markers[index] = [];
      }

      locations.forEach(function (loc, idx) {
        switch (loc.waypointType) {
          case 'P':
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['red'];
            break;

          case 'D':
            icon['path'] = _mapWorld.DROP_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['blue'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -28
            };
            break;

          case 'T':
            icon['path'] = _mapWorld.ACTION_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['purple'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -25
            };
            break;

          case 'R':
            icon['path'] = _mapWorld.RAILWAY_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['black'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -25
            };
            break;

          default:
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['blue'];
            break;
        }

        var marker = {
          position: new google.maps.LatLng(loc['latitude'], loc['longitude']),
          title: hasLabel ? loc.waypointType === 'R' ? 'T' : (idx + 1).toString() : 'P',
          label: {
            text: hasLabel ? loc.waypointType === 'R' ? 'T' : (idx + 1).toString() : 'P',
            color: 'white'
          },
          icon: icon,
          map: _this4.map
        };

        _this4.markers[index].push(new google.maps.Marker(marker));
      });
    }
  }, {
    key: "initSelectedOrderMarker",
    value: function initSelectedOrderMarker(locations) {
      var _this5 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var hasLabel = locations.length > 1;
      var icon = {
        path: _mapWorld.PICK_ICON,
        fillColor: _mapWorld.DEFAULT_MAP_COLOR['blue'] || '#387fc2',
        fillOpacity: 0.8,
        strokeWeight: 0,
        scale: hasLabel ? 0.5 : 0.8,
        labelOrigin: {
          x: 0.9,
          y: 0
        }
      };

      if (!this.markers[index]) {
        this.markers[index] = [];
      }

      var infoWindows = [];
      locations.forEach(function (loc, idx) {
        switch (loc.waypointType) {
          case 'P':
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['red'];
            break;

          case 'D':
            icon['path'] = _mapWorld.DROP_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['blue'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -28
            };
            break;

          case 'T':
            icon['path'] = _mapWorld.ACTION_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['purple'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -25
            };
            break;

          case 'R':
            icon['path'] = _mapWorld.RAILWAY_ICON;
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['black'];
            icon['labelOrigin'] = {
              x: 0.9,
              y: -25
            };
            break;

          default:
            icon['fillColor'] = _mapWorld.DEFAULT_MAP_COLOR['blue'];
            break;
        }

        var markerLabel = function markerLabel() {
          if (!hasLabel) {
            return 'P';
          }

          switch (loc.waypointType) {
            case 'P':
              return 'P';

            case 'R':
              return 'T';

            default:
              return loc['tableIndex'].toString();
          }
        };

        var marker = {
          position: new google.maps.LatLng(loc['latitude'], loc['longitude']),
          title: markerLabel(),
          label: {
            text: markerLabel(),
            color: 'white'
          },
          icon: icon,
          map: _this5.map
        };
        marker['details'] = _objectSpread({}, loc);
        var gMarker = new google.maps.Marker(marker);
        infoWindows.push(new google.maps.InfoWindow({
          content: _this5.getSelectedOrderDetails(gMarker)
        }));
        gMarker.addListener('click', function (event) {
          infoWindows.forEach(function (infoWindow) {
            if (infoWindow.getMap()) {
              infoWindow.close();
            }
          });
          infoWindows[idx].open(_this5.map, gMarker);
        });
      });
    }
  }, {
    key: "addMarker",
    value: function addMarker(locations) {
      var _this6 = this;

      var colorCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var icon = {
        path: _mapWorld.PICK_ICON,
        fillColor: colorCode || '#387fc2',
        fillOpacity: 0.8,
        strokeWeight: 0,
        scale: 0.5,
        labelOrigin: {
          x: 0.9,
          y: 0
        }
      };

      if (!this.markers[index]) {
        this.markers[index] = [];
      }

      locations.forEach(function (loc, idx) {
        _this6.markers[index].push(new google.maps.Marker({
          position: new google.maps.LatLng(loc['latitude'], loc['longitude']),
          title: (idx + 1).toString(),
          label: {
            text: (idx + 1).toString(),
            color: 'white'
          },
          icon: icon,
          map: _this6.map
        }));
      });
      this.fitBounds(this.markers[0]);
    }
  }, {
    key: "removeMarker",
    value: function removeMarker() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.markers[index] && this.markers[index].length >= 1) {
        this.markers[index].forEach(function (loc) {
          if (typeof loc.setMap === 'function') {
            loc.setMap(null);
          }
        });
        this.markers[index] = [];
      }
    }
  }, {
    key: "initRectangle",
    value: function initRectangle(locations) {
      var _this7 = this;

      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#387fc2';
      this.hasRectangles = true;
      this.currentColor = color;

      if (this.hasRectangles && this.rectangles.length >= 1) {
        this.rectangles.forEach(function (loc) {
          loc.setMap(null);
        });
      }

      locations.forEach(function (loc) {
        if (loc.sw && loc.ne && _this7.map) {
          var recData = new google.maps.Rectangle({
            bounds: new google.maps.LatLngBounds(new google.maps.LatLng(loc.sw.lat, loc.sw.lon), new google.maps.LatLng(loc.ne.lat, loc.ne.lon)),
            strokeColor: _this7.currentColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: _this7.currentColor,
            fillOpacity: 0.5,
            map: _this7.map
          });
          recData.addListener('click', function (event) {
            _this7.$emit('updateLocation', {
              latitude: event.latLng.lat(),
              longitude: event.latLng.lng(),
              option: 'remove'
            });

            recData.setMap(null);
          });

          _this7.rectangles.push(recData);
        }
      });
    }
  }, {
    key: "clearRectangle",
    value: function clearRectangle() {
      this.hasRectangles = false;
      this.currentColor = '#387fc2';

      if (this.rectangles && this.rectangles.length >= 1) {
        this.rectangles.forEach(function (loc) {
          loc.setMap(null);
        });
      }
    }
  }, {
    key: "addRectangle",
    value: function addRectangle(loc) {
      var _this8 = this;

      if (loc.sw && loc.ne && this.map && this.hasRectangles) {
        var recData = new google.maps.Rectangle({
          bounds: new google.maps.LatLngBounds(new google.maps.LatLng(loc.sw.lat, loc.sw.lon), new google.maps.LatLng(loc.ne.lat, loc.ne.lon)),
          strokeColor: this.currentColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.currentColor,
          fillOpacity: 0.5,
          map: this.map
        });
        recData.addListener('click', function (event) {
          _this8.$emit('updateLocation', {
            latitude: event.latLng.lat(),
            longitude: event.latLng.lng(),
            option: 'remove'
          });

          recData.setMap(null);
        });
        this.rectangles.push(recData);
      }
    }
  }, {
    key: "initAllRectangle",
    value: function initAllRectangle(locations) {
      var _this9 = this;

      this.clearRectangle();
      var hashcodes = locations.reduce(function (finalCodes, location) {
        if (location['hashCodes'] && location['hashCodes'].length >= 1) {
          location['hashCodes'].forEach(function (loc) {
            var code = _this9.helper.hashBounderies(loc);

            if (code) {
              finalCodes.push(_objectSpread(_objectSpread({}, code), {}, {
                color: location['color'] || '#387fc2'
              }));
            }
          });
        }

        return finalCodes;
      }, []);
      hashcodes.forEach(function (loc, idx) {
        if (loc.sw && loc.ne && _this9.map) {
          var recData = new google.maps.Rectangle({
            bounds: new google.maps.LatLngBounds(new google.maps.LatLng(loc.sw.lat, loc.sw.lon), new google.maps.LatLng(loc.ne.lat, loc.ne.lon)),
            strokeColor: loc.color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: loc.color,
            fillOpacity: 0.5,
            map: _this9.map
          });

          _this9.rectangles.push(recData);
        }
      });
    }
  }, {
    key: "initPolyline",
    value: function initPolyline(locations, planId, isRedrawMarkerOnly) {
      var _this10 = this;

      /*if (this.directionsDisplay !== null) {
          this.directionsDisplay.setMap(null);
          this.directionsDisplay = null;
      }*/
      if (this.polyline !== null && !isRedrawMarkerOnly) {
        this.polyline.setMap(null);
        this.polyline = null;
      }

      if (locations && locations.length >= 2) {
        var coordinates = [];
        locations.forEach(function (loc) {
          if (loc.latitude && loc.longitude) {
            coordinates.push({
              latitude: Number(loc.latitude),
              longitude: Number(loc.longitude),
              waypointType: loc.waypointType || 'P',
              district: loc.district,
              address: loc.displayAddress || loc.address,
              startTime: loc.startTime,
              travellingTime: (loc.time || loc.runningTime) / 60,
              eta: loc.estimateTime,
              waitingTime: loc.waitingTime / 60,
              handlingTime: loc.handlingTime / 60,
              endTime: loc.endTime,
              shipmentReference: loc.shipmentReference,
              orderId: loc.orderId,
              planId: loc.planId,
              truckId: loc.truckId,
              code: loc.code,
              isFrom: loc.isFrom
            });
          }
        });
        var planIds = this.helper.uniq(coordinates.map(function (i) {
          return i.planId;
        }));
        var groupedCoordinates = this.helper.groupBy(coordinates, 'planId');
        var sortedGroupedCoordinates = [];
        planIds.forEach(function (pId) {
          sortedGroupedCoordinates.push(groupedCoordinates[pId]);
        });
        var mappedLatLngs = coordinates.map(function (i, x) {
          return {
            latitude: i['latitude'],
            longitude: i['longitude'],
            index: x + 1,
            shipmentReference: i['shipmentReference'],
            orderId: i['orderId']
          };
        });
        var lookup = mappedLatLngs.reduce(function (acc, val) {
          var key = [val.latitude, val.longitude].join();
          acc[key] = ++acc[key] || 0;
          return acc;
        }, {});
        var duplicatedLatLngs = mappedLatLngs.filter(function (i) {
          var key = [i.latitude, i.longitude].join();
          return lookup[key];
        });
        var groupedLatLngs = this.helper.groupBy(duplicatedLatLngs, function (i) {
          return [i.latitude, i.longitude].join();
        });
        var dupLatLngs = [];

        var _loop = function _loop() {
          var _Object$entries$_i = (0, _slicedToArray2.default)(_Object$entries[_i], 2),
              key = _Object$entries$_i[0],
              locs = _Object$entries$_i[1];

          var latitude = Number(key.split(',')[0]);
          var longitude = Number(key.split(',')[1]);
          var obj = {
            latitude: latitude,
            longitude: longitude,
            index: [],
            shipmentReference: [],
            orderId: []
          };
          locs.forEach(function (loc) {
            var _obj$shipmentReferenc, _obj$orderId;

            obj.index.push(loc.index);

            (_obj$shipmentReferenc = obj.shipmentReference).push.apply(_obj$shipmentReferenc, (0, _toConsumableArray2.default)(loc.shipmentReference));

            (_obj$orderId = obj.orderId).push.apply(_obj$orderId, (0, _toConsumableArray2.default)(loc.orderId));
          });
          dupLatLngs.push(obj);
        };

        for (var _i = 0, _Object$entries = Object.entries(groupedLatLngs); _i < _Object$entries.length; _i++) {
          _loop();
        }

        var infowindow = new google.maps.InfoWindow();
        var directionsService = new google.maps.DirectionsService();
        var idx = 0;
        var colorByPlanId = [];
        sortedGroupedCoordinates.forEach(function (locs, index) {
          var color = _mapWorld.DEFAULT_COLOR_PALETTES[index] !== undefined ? _mapWorld.DEFAULT_COLOR_PALETTES[index] : _this10.helper.randomColor;

          var res = _this10.drawPolylineMarkers({
            locs: locs,
            idx: idx,
            color: color,
            planId: planId,
            duplicatedLatLngs: duplicatedLatLngs,
            dupLatLngs: dupLatLngs,
            infowindow: infowindow
          });

          idx = res.idx;
          color = res.color;
          colorByPlanId.push({
            planId: locs[0].planId,
            color: color
          });

          if (!isRedrawMarkerOnly) {
            _this10.drawPolylineRoutes({
              locs: locs,
              directionsService: directionsService,
              color: color
            });
          }
        });
        this.$emit('onColorByPlanIdChange', colorByPlanId);
      }
    }
  }, {
    key: "drawPolylineMarkers",
    value: function drawPolylineMarkers(_ref) {
      var _this11 = this;

      var locs = _ref.locs,
          idx = _ref.idx,
          color = _ref.color,
          planId = _ref.planId,
          duplicatedLatLngs = _ref.duplicatedLatLngs,
          dupLatLngs = _ref.dupLatLngs,
          infowindow = _ref.infowindow;
      locs.forEach(function (loc) {
        idx++;
        var iconPath = _mapWorld.PICK_ICON;
        var labelOrigin = {
          x: 0.9,
          y: 0
        };

        switch (loc.waypointType) {
          case 'P':
            color = _this11.helper.isUndefined(planId) || loc.planId === planId || !loc.isFrom ? color : _mapWorld.DEFAULT_MAP_COLOR['grey'];
            break;

          case 'D':
            iconPath = _mapWorld.DROP_ICON;
            labelOrigin = {
              x: 0.9,
              y: -28
            };
            color = _this11.helper.isUndefined(planId) || loc.planId === planId || !loc.isFrom ? color : _mapWorld.DEFAULT_MAP_COLOR['grey'];
            break;

          case 'T':
            iconPath = _mapWorld.ACTION_ICON;
            labelOrigin = {
              x: 0.9,
              y: -25
            };
            color = _this11.helper.isUndefined(planId) || loc.planId === planId || !loc.isFrom ? color : _mapWorld.DEFAULT_MAP_COLOR['grey'];
            break;

          case 'R':
            iconPath = _mapWorld.RAILWAY_ICON;
            labelOrigin = {
              x: 0.9,
              y: -25
            };
            color = _this11.helper.isUndefined(planId) || loc.planId === planId || !loc.isFrom ? color : _mapWorld.DEFAULT_MAP_COLOR['grey'];
            break;
        }

        var isMarkerSelected = false;

        if (_this11.selectedShipRefs.length) {
          var intersectArr = _this11.helper.intersection(loc.shipmentReference, _this11.selectedShipRefs);

          isMarkerSelected = intersectArr.length > 0;
        }

        var icon = {
          path: iconPath,
          fillColor: color,
          fillOpacity: 0.8,
          strokeWeight: isMarkerSelected ? 2 : 0,
          scale: isMarkerSelected ? 0.55 : 0.5,
          labelOrigin: labelOrigin
        };
        var marker = new google.maps.Marker({
          position: new google.maps.LatLng(loc.latitude, loc.longitude),
          title: idx.toString(),
          label: {
            text: idx.toString(),
            color: 'white'
          },
          icon: icon,
          map: _this11.map,
          details: loc
        });

        _this11.polylineMarkers.push(marker); // Array of current truck waypoints


        if ((_this11.helper.isUndefined(planId) || loc.planId === planId) && loc.isFrom) {
          marker.addListener('click', function (event) {
            // Disable marker click if planId belong to another user
            if (!_this11.isPlanIdBelongToDifferentUser(loc.planId, loc.truckId)) {
              var isLatLngDuplicate = _this11.helper.some(duplicatedLatLngs, function (i) {
                return i.latitude === loc.latitude && i.longitude === loc.longitude;
              });

              if (isLatLngDuplicate) {
                infowindow.close();
                infowindow.setContent(_this11.showDuplicateLatLngWindow({
                  dupLatLngs: dupLatLngs,
                  loc: loc
                }));
                infowindow.open(_this11.map, marker);
              } else if (loc.shipmentReference.length > 1) {
                infowindow.close();
                infowindow.setContent(_this11.showDuplicateShipRefWindow({
                  point: loc
                }));
                infowindow.open(_this11.map, marker);
              } else {
                _this11.$emit('selectShipRef', loc.shipmentReference[0]);
              }
            }
          });
        }
      });
      return {
        idx: idx,
        color: color
      };
    }
  }, {
    key: "drawPolylineRoutes",
    value: function drawPolylineRoutes(_ref2) {
      var _this12 = this;

      var locs = _ref2.locs,
          directionsService = _ref2.directionsService,
          color = _ref2.color;

      /**
       * Divide route to several parts
       * because max stations limit is 25
       * (24 waypoints + 1 origin + 1 destination)
       * */
      var formattedLocs = locs.map(function (loc) {
        return {
          pointType: loc.waypointType || '',
          latLng: new google.maps.LatLng(loc.latitude, loc.longitude)
        };
      });
      var parts = [];

      for (var i = 0, max = 25 - 1; i < formattedLocs.length; i = i + max) {
        parts.push(formattedLocs.slice(i, i + max + 1));
      }

      parts.forEach(function (part) {
        var waypoints = [];

        for (var j = 1; j < part.length - 1; j++) {
          waypoints.push({
            location: part[j]['latLng'],
            stopover: false
          });
        }

        var directionRequest = {
          origin: part[0]['latLng'],
          destination: part[part.length - 1]['latLng'],
          waypoints: waypoints,
          travelMode: google.maps.DirectionsTravelMode.DRIVING,
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'optimistic'
          }
        };

        _this12.getDirectionRoute(directionsService, directionRequest, color);
      });
    }
  }, {
    key: "drawPolygonTransferPlan",
    value: function drawPolygonTransferPlan() {
      var _this13 = this;

      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#387fc2';
      this.hasRectangles = true;
      this.currentColor = color;
      this.clearPolygon(false);

      if (this.map) {
        var recData = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: false,
          polygonOptions: {
            strokeColor: this.currentColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.currentColor,
            fillOpacity: 0.5,
            editable: true
          },
          map: this.map
        });
        recData.addListener('polygoncomplete', function (e) {
          recData.setDrawingMode(null);
          _this13.rectangles[0] = e;
          var selectedShipRefs = [];

          if (_this13.polylineMarkers.length) {
            _this13.polylineMarkers.forEach(function (i) {
              var isInside = google.maps.geometry.poly.containsLocation(i.position, e);

              if (isInside && i.details.isFrom) {
                var _selectedShipRefs;

                (_selectedShipRefs = selectedShipRefs).push.apply(_selectedShipRefs, (0, _toConsumableArray2.default)(i.details.shipmentReference));
              }
            });
          }

          selectedShipRefs = _this13.helper.uniq(selectedShipRefs);

          if (selectedShipRefs.length) {
            _this13.$emit('polygonComplete', selectedShipRefs);
          }
        });
        this.rectangles.push(recData);
      }
    }
  }, {
    key: "clearMarker",
    value: function clearMarker() {
      if (this.polylineMarkers.length === 0) {
        return;
      }

      this.polylineMarkers.forEach(function (marker) {
        marker.setMap(null);
      });
      this.polylineMarkers = [];
    }
  }, {
    key: "showDuplicateLatLngWindow",
    value: function showDuplicateLatLngWindow(_ref3) {
      var dupLatLngs = _ref3.dupLatLngs,
          loc = _ref3.loc;
      var obj = dupLatLngs.find(function (i) {
        return i.latitude === loc.latitude && i.longitude === loc.longitude;
      });
      return this.showDuplicateShipRefWindow({
        point: _objectSpread(_objectSpread({}, loc), obj)
      });
    }
  }, {
    key: "showDuplicateShipRefWindow",
    value: function showDuplicateShipRefWindow(_ref4) {
      var _this14 = this;

      var point = _ref4.point;
      var btnStr = '';
      var shipRefs = this.helper.uniq(this.helper.get(point, 'shipmentReference', []));
      shipRefs.forEach(function (i) {
        var className = 'mt-1 ml-1 el-button el-button--mini';
        className += _this14.selectedShipRefs.includes(i) ? ' el-button--primary' : ' el-button--default';
        btnStr += "<button class=\"".concat(className, "\" onclick=\"selectMarkerByShipRefs('").concat(i, "')\">").concat(i, "</button>");
      });
      return "\n\t\t\t<div style=\"color: #606266\">\n\t\t\t\t<span class=\"ml-1 bold\">".concat(this.$i18n.t('planning.gMap.address'), ": </span>").concat(point.address, "<br>\n\t\t\t\t<span class=\"ml-1 bold\">").concat(this.$i18n.t('planning.gMap.shipRefs'), ": </span><br>\n\t\t\t\t").concat(btnStr, "\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "selectMarkerByShipRefs",
    value: function selectMarkerByShipRefs(i) {
      this.$emit('selectShipRef', i);
    } // To draw individual waypoint direction route, more google api calls

  }, {
    key: "getDirectionRoute",
    value: function getDirectionRoute(directionsService, directionRequest, color) {
      var _this15 = this;

      directionsService.route(directionRequest, function (response, status) {
        if (status === google.maps.DirectionsStatus.OK) {
          /*const directionsOptions = {
                  suppressMarkers: true,
                  preserveViewport: true,
              };
              this.directionsDisplay = new google.maps.DirectionsRenderer(directionsOptions);
              this.directionsDisplay.setDirections(response);
              this.directionsDisplay.setMap(this.map);*/
          var path = [];
          response.routes[0].overview_path.forEach(function (i) {
            path.push(i);
          });
          var polyOptions = {
            strokeColor: color,
            strokeOpacity: 0.5,
            strokeWeight: 4,
            path: path,
            map: _this15.map
          };
          _this15.polyline = new google.maps.Polyline(polyOptions);

          _this15.polyline.setMap(_this15.map);
        } else if (status === google.maps.DirectionsStatus.OVER_QUERY_LIMIT) {
          _this15.delayFactor++;
          setTimeout(function () {
            _this15.getDirectionRoute(directionsService, directionRequest, color);
          }, _this15.delayFactor * 1000);
        }
      });
    }
  }, {
    key: "clearPolygon",
    value: function clearPolygon() {
      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (clear) {
        this.hasRectangles = false;
        this.currentColor = '#387fc2';
      }

      if (this.rectangles && this.rectangles.length >= 1) {
        this.rectangles.forEach(function (loc) {
          loc.setMap(null);
        });
      }

      this.rectangles = [];
    }
  }, {
    key: "drawPolygon",
    value: function drawPolygon() {
      var _this16 = this;

      var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#387fc2';
      this.hasRectangles = true;
      this.currentColor = color;
      this.clearPolygon(false);

      if (this.map) {
        var recData = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: false,
          polygonOptions: {
            strokeColor: this.currentColor,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: this.currentColor,
            fillOpacity: 0.5,
            editable: true
          },
          map: this.map
        });
        recData.addListener('polygoncomplete', function (event) {
          recData.setDrawingMode(null);
          _this16.rectangles[0] = event;
        });
        this.rectangles.push(recData);
      }
    }
  }, {
    key: "drawPolygonWithOverlay",
    value: function drawPolygonWithOverlay(_ref5) {
      var _this17 = this;

      var locationList = _ref5.locationList,
          color = _ref5.color;

      if (!this.map) {
        return;
      }

      this.hasRectangles = true;
      this.currentColor = color || '#387fc2';
      this.clearPolygon(false);
      var recData = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: false,
        polygonOptions: {
          strokeColor: this.currentColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.currentColor,
          fillOpacity: 0.5,
          editable: true
        },
        map: this.map
      });
      recData.addListener('polygoncomplete', function (event) {
        recData.setDrawingMode(null);
        _this17.rectangles[0] = event;
      });
      this.rectangles.push(recData);
      this.initAllPolygon(locationList, false, false);
    }
  }, {
    key: "initPolygon",
    value: function initPolygon(locations) {
      var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#387fc2';
      this.hasRectangles = true;
      this.currentColor = color;
      this.clearPolygon(false);

      if (locations && locations.length >= 3 && this.map) {
        var finalWayPoints = [];
        locations.forEach(function (loc) {
          var floc = loc.split(',');

          if (floc.length === 2) {
            finalWayPoints.push(new google.maps.LatLng(Number(floc[0]), Number(floc[1])));
          }
        });
        var recData = new google.maps.Polygon({
          paths: finalWayPoints || [],
          strokeColor: this.currentColor,
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: this.currentColor,
          fillOpacity: 0.5,
          map: this.map,
          editable: true
        });
        this.rectangles.push(recData);
      }
    }
  }, {
    key: "initPolygonWithOverlay",
    value: function initPolygonWithOverlay(_ref6) {
      var locations = _ref6.locations,
          currZoneId = _ref6.currZoneId,
          locationList = _ref6.locationList,
          color = _ref6.color;

      if (!this.map || !locations || locations.length < 3) {
        return;
      }

      this.hasRectangles = true;
      this.currentColor = color || '#387fc2';
      this.clearPolygon(false);
      var zoneWaypoints = [];
      locations.forEach(function (loc) {
        var floc = loc.split(',');

        if (floc.length === 2) {
          zoneWaypoints.push(new google.maps.LatLng(Number(floc[0]), Number(floc[1])));
        }
      });
      var zonePloygon = new google.maps.Polygon({
        paths: zoneWaypoints || [],
        strokeColor: this.currentColor,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: this.currentColor,
        fillOpacity: 0.5,
        map: this.map,
        editable: true
      });
      this.rectangles.push(zonePloygon);
      this.initAllPolygon(locationList, false, false, currZoneId);
    }
  }, {
    key: "initAllPolygon",
    value: function initAllPolygon(locations) {
      var _this18 = this;

      var isObject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isClearPolygon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var filteredOutZoneId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      if (isClearPolygon) {
        this.clearPolygon(true);
      }

      var allZoneWaypoints = locations.filter(function (i) {
        return _this18.helper.isUndefined(filteredOutZoneId) ? i : i._id !== filteredOutZoneId;
      }).reduce(function (finalCodes, location) {
        if (location['wayPoints'] && location['wayPoints'].length >= 1) {
          var finalWayPoints = [];
          location['wayPoints'].forEach(function (loc) {
            if (isObject) {
              if (loc['waypoint']) {
                var floc = loc['waypoint'].split(',');

                if (floc.length === 2) {
                  finalWayPoints.push(new google.maps.LatLng(Number(floc[0]), Number(floc[1])));
                }
              }
            } else {
              var _floc = loc.split(',');

              if (_floc.length === 2) {
                finalWayPoints.push(new google.maps.LatLng(Number(_floc[0]), Number(_floc[1])));
              }
            }
          });
          finalCodes.push({
            color: location['color'] || '#387fc2',
            wayPoints: finalWayPoints
          });
        }

        return finalCodes;
      }, []);
      allZoneWaypoints.forEach(function (loc) {
        if (loc['wayPoints'] && loc['wayPoints'].length >= 3 && _this18.map) {
          var polygonData = new google.maps.Polygon({
            paths: loc['wayPoints'] || [],
            strokeColor: loc['color'],
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: loc['color'],
            fillOpacity: 0.5,
            map: _this18.map
          });

          _this18.rectangles.push(polygonData);
        }
      });
    }
  }, {
    key: "initAllHeatMap",
    value: function initAllHeatMap(locations) {
      if (locations && locations.length >= 1 && this.map) {
        var finalWayPoints = [];
        locations.forEach(function (loc) {
          if (loc.length === 2) {
            finalWayPoints.push({
              location: new google.maps.LatLng(Number(loc[0]), Number(loc[1])),
              weight: 0.5
            });
          }
        });
        new google.maps.visualization.HeatmapLayer({
          data: finalWayPoints,
          radius: 20,
          map: this.map
        });
      }
    }
  }, {
    key: "getSelectedOrderDetails",
    value: function getSelectedOrderDetails(marker) {
      return "\n\t\t\t<div style=\"color: #606266\">\n\t\t\t\t<span class=\"bold\">".concat(marker.details.tableIndex, "</span><br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.gMap.type'), ": </span>").concat(marker.details.waypointType, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.gMap.address'), ": </span>").concat(marker.details.address1, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.gMap.address'), ": </span>").concat(marker.details.address2, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.tooltip.start'), ": </span>").concat(marker.details.startTime, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.columns.quantity'), ": </span>").concat(marker.details.quantity, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.columns.weight'), ": </span>").concat(marker.details.weight, "<br>\n\t\t\t\t<span class=\"bold\">").concat(this.$i18n.t('planning.columns.volume'), ": </span>").concat(marker.details.volume, "\n\t\t\t</div>\n\t\t");
    }
  }, {
    key: "fitBounds",
    value: function fitBounds() {
      var _this19 = this;

      var locations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var latLngs = locations.length > 0 ? locations : this.helper.get(this.$props, 'routes', []);

      if (this.helper.isUndefined(this.map) || latLngs.length === 0) {
        return;
      }

      if (this.bounds !== null) {
        this.bounds = null;
      }

      this.bounds = new google.maps.LatLngBounds();
      latLngs.forEach(function (loc) {
        var lat = null;
        var lng = null;

        if (loc.hasOwnProperty('position')) {
          lat = loc.position.lat();
          lng = loc.position.lng();
        } else {
          lat = loc.latitude || loc[0];
          lng = loc.longitude || loc[1];
        }

        if (lat && lng) {
          var latLng = new google.maps.LatLng(lat, lng);

          _this19.bounds.extend(latLng);
        }
      });

      if (!this.bounds.isEmpty()) {
        this.map.setCenter(this.bounds.getCenter());
        this.map.fitBounds(this.bounds);
      }
    } // duplicated

  }, {
    key: "isPlanIdBelongToDifferentUser",
    value: function isPlanIdBelongToDifferentUser(planId, truckId) {
      var _this20 = this;

      var isAllowEditOtherUserData = this.$userData.updateUserData || false;
      var truck = this.getTruckInPlan(truckId);

      if (truck) {
        return this.helper.some(truck['routes'], function (route) {
          return route.planId === planId && _this20.isRouteBelongToDifferentUser(route);
        }) && !isAllowEditOtherUserData;
      }

      return false;
    } // duplicated

  }, {
    key: "isRouteBelongToDifferentUser",
    value: function isRouteBelongToDifferentUser(route) {
      if (!route.hasOwnProperty('user')) {
        return false;
      }

      if (route.hasOwnProperty('user') && this.$userInformation && this.$userInformation.user) {
        return route['user'] !== this.$userInformation.user.name;
      }

      return false;
    } // duplicated

  }, {
    key: "getTruckInPlan",
    value: function getTruckInPlan(truckId) {
      return this.helper.get(this.helper.filter(this.$props.plan.trucks, function (truck) {
        return truck['truckId'] === truckId;
      }), '0', null);
    }
  }]);
  return MapWorldComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin, _logger.LoggerMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userInformation', {
  namespace: 'authentication'
})], MapWorldComponent.prototype, "$userInformation", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userData', {
  namespace: 'authentication'
})], MapWorldComponent.prototype, "$userData", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  required: true
})], MapWorldComponent.prototype, "locations", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array
})], MapWorldComponent.prototype, "routes", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Boolean,
  default: false
})], MapWorldComponent.prototype, "hasUpdateEvent", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String
})], MapWorldComponent.prototype, "initEvent", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Number,
  default: 6
})], MapWorldComponent.prototype, "precision", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  default: function _default() {
    return [];
  }
})], MapWorldComponent.prototype, "selectedShipRefs", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Object,
  default: null
})], MapWorldComponent.prototype, "plan", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)('selectedShipRefs')], MapWorldComponent.prototype, "onSelectedShipRefsChange", null);
MapWorldComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'MapWorldComponent'
})], MapWorldComponent);
var _default2 = MapWorldComponent;
exports.default = _default2;